import { logger } from '@ahaslides-product/frontend-toolkit'

// Set of socket actions to ignore in logging
const IGNORED_SOCKET_ACTIONS = new Set([
  'create-reaction',
])

const LogWebsocketSubscriber = {
  init: (socket) => {
    const socketLog = logger.extend('socket')
    socket.onAny((eventName, ...args) => {
      // Skip logging for ignored socket actions
      if (IGNORED_SOCKET_ACTIONS.has(eventName)) {
        return
      }

      socketLog(`${eventName}`, args)
    })
  },
}

export default LogWebsocketSubscriber
